(function (angular) {
  class CCPaymentFormStripeCtrl {
    constructor($log, $scope, PaymentsService) {
      'ngInject';

      angular.extend(this, {
        $log,
        $scope,
        PaymentsService
      });
      this.validCardNumber = false;
      this.validCardExpiry = false;
      this.validCardCvc = false;
      this.formValid = false;
    }

    $onInit() {
      const this2 = this;
      this.displayError = ''; // Create a Stripe client.

      this.stripe = Stripe(this.stripeApiKey); // Create an instance of Elements.

      this.elements = this.stripe.elements(); // Custom styling can be passed to options when creating an Element

      this.style = {
        base: {
          color: '#32325d',
          lineHeight: '18px',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      };
      this.cardNumber = this.elements.create('cardNumber', {
        style: this.style
      });
      this.cardNumber.mount('#card-number-element');
      this.cardExpiry = this.elements.create('cardExpiry', {
        style: this.style
      });
      this.cardExpiry.mount('#card-expiry-element');
      this.cardCvc = this.elements.create('cardCvc', {
        style: this.style
      });
      this.cardCvc.mount('#card-cvc-element');
      const elements = [this.cardNumber, this.cardExpiry, this.cardCvc]; // Listen for errors from each Element, and show error messages in the UI.

      elements.forEach(function (element, index) {
        element.on('change', function (event) {
          // We clear parent controller error messages
          this2.errors = [];

          if (event.error) {
            this2.formValid = false;

            if (index === 0) {
              this2.validCardNumber = false;
            } else if (index === 1) {
              this2.validCardExpiry = false;
            } else if (index === 2) {
              this2.validCardCvc = false;
            }

            const displayError = document.getElementById('card-errors');
            this2.displayError = event.error.message;
            displayError.classList.add('alert', 'alert-danger');
            this2.$scope.$apply();
          } else if (!event.complete) {
            this2.formValid = false;

            if (index === 0) {
              this2.validCardNumber = false;
            } else if (index === 1) {
              this2.validCardExpiry = false;
            } else if (index === 2) {
              this2.validCardCvc = false;
            }

            this2.$scope.$apply();
          } else if (event.complete) {
            if (index === 0) {
              this2.validCardNumber = true;
            } else if (index === 1) {
              this2.validCardExpiry = true;
            } else if (index === 2) {
              this2.validCardCvc = true;
            }

            if (this2.validCardNumber && this2.validCardExpiry && this2.validCardCvc) {
              this2.formValid = true; // this2.$scope.$apply()
            }

            const displayError = document.getElementById('card-errors');
            this2.displayError = '';
            displayError.classList.remove('alert', 'alert-danger');
            this2.$scope.$apply();
          }
        });
      });
    }

    handleSubmit() {
      const this2 = this;
      if (!this.formValid) return; // this.PaymentsService.getTransactionObject()

      this.PaymentsService.postTransactionObject(this.userId).then(({
        data
      }) => {
        const clientSecret = data.payment_object.client_secret;
        this.stripe.confirmCardSetup(clientSecret, {
          payment_method: {
            card: this.cardNumber
          }
        }).then(result => {
          const displayError = document.getElementById('card-errors');

          if (result.error) {
            this2.displayError = result.error.message;
            displayError.classList.add('alert', 'alert-danger'); // Tracking Stripe Frontend errors on Mongo DB

            this2.Tracking.trackError(result.error, 'Stripe-Error-Log-Frontend-Token').catch(trackingErr => {
              this2.$log.debug(trackingErr);
            });
          } else {
            this2.displayError = '';
            displayError.classList.remove('alert', 'alert-danger');
            this2.onSubmit({
              data: {
                setupIntent: result.setupIntent
              }
            });
          }
        });
      });
    }

  }

  CCPaymentFormStripeCtrl.$inject = ["$log", "$scope", "PaymentsService"];
  angular.module('pims').component('ccPaymentFormStripe', {
    template: `
      <div>
        <form id="credit-card-form">
          <div class="form-row" style="margin-bottom: 20px;">
            <label for="card-number-element" style="margin-left: 48px;color: #454545;">
              &nbsp; Card Number
            </label>
            <div id="card-number-element" style="width: 400px; border: 1px solid #d3d3d3; border-radius: 4px; margin: auto;">
              <!-- A Stripe Element will be inserted here. -->
            </div>
          </div>

          <div class="form-row" style="width: 200px; display: inline-block;">
            <label for="card-expiry-element" style="margin-left: 48px; color: #454545;">
              &nbsp; Expiration Date
            </label>
            <div id="card-expiry-element" style="width: 200px; border: 1px solid #d3d3d3; border-radius: 4px; width: 150px; margin-left: 50px;">
              <!-- A Stripe Element will be inserted here. -->
            </div>
          </div>

          <div class="form-row" style="width: 150px; display: inline-block; margin-right: 50px; float: right;">
            <label for="card-cvc-element" style="color: #454545;">
              &nbsp; Security Code
            </label>
            <div id="card-cvc-element" style="border: 1px solid #d3d3d3; border-radius: 4px; width: 150px;">
              <!-- A Stripe Element will be inserted here. -->
            </div>
          </div>

          <div class="form-row" style="padding-top: 35px;width: 300px;text-align: center;margin: auto;">
            <!-- Used to display form errors. -->
            <div ng-bind="$ctrl.displayError" id="card-errors" role="alert"></div>
          </div>

          <payment-button payment-in-process="$ctrl.paymentInProcess" form-valid="$ctrl.formValid" on-click="$ctrl.handleSubmit()">
          </payment-button>
        </form>
      </div>
    `,
    controller: CCPaymentFormStripeCtrl,
    bindings: {
      stripeApiKey: '<',
      paymentInProcess: '<',
      userId: '<',
      onSubmit: '&',
      errors: '='
    }
  });
})(angular);